import firebase from 'firebase'

const firebaseConfig = {
    production: {
        apiKey: "AIzaSyCx9awub1QdYorpNPfvfM98svtLoGyKz-U",
        authDomain: "crossprom-firebase.firebaseapp.com",
        databaseURL: "https://crossprom-firebase.firebaseio.com",
        projectId: "crossprom-firebase",
        storageBucket: "crossprom-firebase.appspot.com",
        messagingSenderId: "434638711869",
        appId: "1:434638711869:web:d7e3295a30fc6df3"
    },
    staging: {
        apiKey: "AIzaSyBkbP1CuN8Emu-lMbncnh70EFKCT1A4AXM",
        authDomain: "crossprom-staging.firebaseapp.com",
        databaseURL: "https://crossprom-staging.firebaseio.com",
        projectId: "crossprom-staging",
        storageBucket: "crossprom-staging.appspot.com",
        messagingSenderId: "811907272397",
        appId: "1:811907272397:web:8fb10669536d4868"
    },
    development: {
        apiKey: "AIzaSyBkbP1CuN8Emu-lMbncnh70EFKCT1A4AXM",
        authDomain: "crossprom-staging.firebaseapp.com",
        databaseURL: "https://crossprom-staging.firebaseio.com",
        projectId: "crossprom-staging",
        storageBucket: "crossprom-staging.appspot.com",
        messagingSenderId: "811907272397",
        appId: "1:811907272397:web:8fb10669536d4868"
    }
}[process.env.NODE_ENV]

const app = firebase.initializeApp(firebaseConfig)

const db = firebase.firestore()
const database = firebase.database() 
const auth = firebase.auth()
const storage = firebase.storage()
const ADMINS = [
    'dMijvVsRTLRML8T3T2em52uLi1e2',
    'KoOaTa59KcURyotggoz1ffmzMM13',
    '1wynaik8Y1XmMSSaggQvuTdcZy53',
    '411ealWetchF6pUM3P9K9ZQYJT92',
    'QPLqkIIoAgN33sLIARjxH4Vrpjk1',
    'QjInXwjYQEUIVoX2TuZDnPvl8J33',
    'uzapYCoDQ1eWPiDop2aGZXzA8OL2'
]

/**
 * FUNCTIONS
 */
export const elasticQuery = app.functions().httpsCallable('elasticQuery')
export const postUpdates = app.functions().httpsCallable('postUpdates')
export const kickstarterLoad = app.functions().httpsCallable('kickstarterLoad')
export const attachShopToRealOwner = app.functions().httpsCallable('attachShopToRealOwner')
export const findShopFromNocoDB = app.functions().httpsCallable('findShopFromNocoDB')
export const message = app.functions().httpsCallable('message')
export const verifyCampaign = app.functions().httpsCallable('manuallyVerifyCampaign')
export const EMAIL_FUNCTION = `https://us-central1-${firebaseConfig.projectId}.cloudfunctions.net/email`

export const ELASTIC_SEARCH_CAMPAIGNS_INDEX = process.env.NODE_ENV === 'production' ? 'crossprom_campaigns' : 'st-crossprom_campaigns'
export const ELASTIC_SEARCH_CP_REQUESTS_INDEX = process.env.NODE_ENV === 'production' ? 'crossprom_cp_requests' : 'st-crossprom_cp_requests'
export const ELASTIC_SEARCH_UPDATES_INDEX = process.env.NODE_ENV === 'production' ? 'crossprom_updates' : 'st-crossprom_updates'
export const ELASTIC_SEARCH_DRAFTS_INDEX = process.env.NODE_ENV === 'production' ? 'crossprom_drafts' : 'st-crossprom_drafts'
export const ELASTIC_SEARCH_SHOPS_INDEX = process.env.NODE_ENV === 'production' ? 'crossprom_shops' : 'st-crossprom_shops'
export const HOST = process.env.NODE_ENV === 'production' ? 'https://crossprom.com' : 'https://crossprom-staging.firebaseapp.com'
export const DEFAULT_CAMPAIGN_COLLECTION = process.env.NODE_ENV === 'production' ? 'drafts' : 'drafts'
export const API_URL = `https://us-central1-${firebaseConfig.projectId}.cloudfunctions.net/stripeAPI`
// export const API_URL = `https://9f72-37-252-92-60.ngrok.io`

export {
    firebaseConfig,
    db,
    auth,
    storage,
    database,
    ADMINS
}

